import actionTypes from '../actionTypes'
import makeUniqueId from 'helpers/makeUniqueId'

const creationToolMcqActions = {
	initializeMcqSuccess: payload => ({
		type: actionTypes.CREATION_TOOL_MCQ_INITIALIZE_SUCCESS,
		payload,
	}),
	initializeMcqError: error => ({
		type: actionTypes.CREATION_TOOL_MCQ_INITIALIZE_ERROR,
		error,
	}),
	questionUpdateSuccess: answers => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_UPDATE_SUCCESS,
		answers,
	}),
	questionUpdateError: error => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_UPDATE_ERROR,
		error,
	}),
	questionChange: value => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_CHANGE,
		value,
	}),
	questionSave: jwt => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_AUTOSAVE,
		jwt,
	}),
	dragAnswer: (draggedAnswer, replacedAnswer) => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_DRAG,
		draggedAnswer,
		replacedAnswer,
	}),
	dropAnswer: () => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_DROP,
	}),
	answerChange: (value, questionId, answerId) => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_CHANGE,
		value,
		questionId,
		answerId,
	}),
	answerSave: questionId => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_AUTOSAVE,
		questionId,
	}),
	addAnswer: () => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_ADD,
		answerId: makeUniqueId(),
	}),
	deleteAnswer: answerId => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_DELETE,
		answerId,
	}),
	answerCheckboxChange: answerId => ({
		type: actionTypes.CREATION_TOOL_MCQ_ANSWER_CHECKBOX_CHANGE,
		answerId,
	}),
	getQuestionSuccess: entity => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_GET_SUCCESS,
		entity,
	}),
	getQuestionError: error => ({
		type: actionTypes.CREATION_TOOL_MCQ_QUESTION_GET_ERROR,
		error,
	}),
}

export default creationToolMcqActions
